import { Icons } from 'bold-ui/lib/components/Icon/generated/types'
import { blue, purple, red, turquoise } from 'bold-ui/lib/styles/colors'
import { TipoMedicaoEnum } from 'graphql/types.generated'
import { ReactComponent as CircAbdominal } from 'images/medical/circunferencia-abdominal-filled.svg'
import { ReactComponent as Glicemia } from 'images/medical/glucometer.svg'
import { ReactComponent as Height } from 'images/medical/height.svg'
import { ReactComponent as Lungs } from 'images/medical/lungs.svg'
import { ReactComponent as PerCefalico } from 'images/medical/perimetro-cefalico-filled.svg'
import { ReactComponent as PerPanturrilha } from 'images/medical/perimetro-panturrilha-filled.svg'
import { ReactComponent as Thermometer } from 'images/medical/thermometer-filled.svg'
import { ReactComponent as Weight } from 'images/medical/weight.svg'
import React from 'react'

export type GrupoMedicoesTipoModel = {
  tipo: TipoMedicaoEnum
  medicoes: MedicaoProntuarioModel[]
}

export type MedicaoProntuarioModel = {
  key: ID
  dataMedicao?: Instant
  valor?: string
  observacao?: string
}

export type TipoMedicaoAtendimento = {
  label?: string
  unidadeMedida?: string
  order?: number
  icon?: Icons
  colorScale?: string
  iconPec?: () => React.ReactNode
}

export const tipoMedicaoRecord: Record<TipoMedicaoEnum, TipoMedicaoAtendimento> = {
  [TipoMedicaoEnum.PESO]: {
    order: 1,
    label: 'Peso',
    unidadeMedida: 'kg',
    iconPec: () => <Weight />,
  },
  [TipoMedicaoEnum.ALTURA]: {
    order: 2,
    label: 'Altura',
    unidadeMedida: 'cm',
    iconPec: () => <Height />,
  },
  [TipoMedicaoEnum.IMC]: {
    order: 3,
    label: 'IMC',
    unidadeMedida: 'kg/m²',
    icon: 'imcFilled',
    colorScale: turquoise.c50,
  },
  [TipoMedicaoEnum.PRESSAO_ARTERIAL]: {
    order: 4,
    label: 'Pressão arterial',
    unidadeMedida: 'mmHg',
    icon: 'bloodPressureFilled',
    colorScale: blue.c50,
  },
  [TipoMedicaoEnum.FREQUENCIA_RESPIRATORIA]: {
    order: 5,
    label: 'Freq. respiratória',
    unidadeMedida: 'mpm',
    iconPec: () => <Lungs />,
  },
  [TipoMedicaoEnum.FREQUENCIA_CARDIACA]: {
    order: 6,
    label: 'Fre. cardíaca',
    unidadeMedida: 'bpm',
    icon: 'heartRateFilled',
    colorScale: red.c50,
  },
  [TipoMedicaoEnum.TEMPERATURA]: {
    order: 7,
    label: 'Temperatura',
    unidadeMedida: 'ºC',
    iconPec: () => <Thermometer />,
  },
  [TipoMedicaoEnum.SATURACAO_O2]: {
    order: 8,
    label: 'Saturação de O2',
    unidadeMedida: '%',
    icon: 'o2Filled',
    colorScale: purple.c50,
  },
  [TipoMedicaoEnum.CIRCUNFERENCIA_ABDOMINAL]: {
    order: 9,
    label: 'Circ. abdominal',
    unidadeMedida: 'cm',
    iconPec: () => <CircAbdominal />,
  },
  [TipoMedicaoEnum.PERIMETRO_CEFALICO]: {
    order: 10,
    label: 'Per. cefálico',
    unidadeMedida: 'cm',
    iconPec: () => <PerCefalico />,
  },
  [TipoMedicaoEnum.PERIMETRO_PANTURRILHA]: {
    order: 11,
    label: 'Per. da panturrilha',
    unidadeMedida: 'cm',
    iconPec: () => <PerPanturrilha />,
  },
  [TipoMedicaoEnum.GLICEMIA]: {
    order: 12,
    label: 'Glicemia capilar',
    unidadeMedida: 'mg/dL',
    iconPec: () => <Glicemia />,
  },
  [TipoMedicaoEnum.DUM]: {}, // Essa informação ainda não é apresentada na lateral do atendimento
  [TipoMedicaoEnum.ALTURA_UTERINA]: {}, // Essa informação ainda não é apresentada na lateral do atendimento
}
